
<button class="btn q-btn q-main m-2" (click)="refreshGrid()" title="actualiser">
  <i class="fas fa-sync-alt"></i>
  Actualiser
</button>

<button class="btn q-btn m-2"
        type="button"
        placement="bottom"
        [ngbPopover]="extranetSharePopover"
        [autoClose]="'outside'"
        #p="ngbPopover"
        #extranetLevelPopover>
  <i class="fas fa-share"></i>
  Partager sur l'extranet
</button>

<button class="btn q-btn q-main m-2" type="button" (click)="genereDocuments()"
        title="Télécharger le(s) document(s)" [disabled]="!lstSelectedDoc?.length">
  <i class="fas fa-file-download"></i>
  Télécharger
</button>

<button class="btn q-btn q-danger m-2" type="button" (click)="open(ModalDeleteValidation, false)"
        title="Supprimer les documents" [disabled]="!selectedNodes?.length">
  <i class="far fa-trash-alt"></i> 
  Supprimer
</button>

<button title="Ajouter un document au stage" class="btn q-btn m-2" (click)="open(ModalInsertDoc, true)">
  <i class="fas fa-upload"></i>
  Ajouter
</button>

<!-- La customgrid -->
<q-customgrid [customgridName]="'ListeDocumentByStage'"
              [idDonnee]="idStage"
              [(refreshData)]="refreshData"
              (selectChanged)="selectLine($event)">

</q-customgrid>

<!-- Template de la popover "partager sur l'extranet"-->
<ng-template #extranetSharePopover>

  <div class="d-flex flex-column" *ngIf="selectedNodes.length > 0">
    <div class="text-center mb-1">Niveau Extranet</div>
    <select class="q-main-select mb-2" [(ngModel)]="nivseDOCSelected">
      <option value="NULL">---------</option>
      <ng-container *ngFor="let option of docService.nivseDOCOptions">
        <option value="{{option.id}}">{{option.value}}</option>
      </ng-container>
    </select>
    <button class="btn q-btn q-main m-2" (click)="updateNivseDOC();p.close()" [disabled]="!nivseDOCSelected" title="Partager"> Partager </button>
  </div>

  <!-- Si aucun document n'est selectionné -->
  <div *ngIf="selectedNodes.length < 1" class="d-flex align-items-center">
    <i class="fas fa-exclamation-triangle mr-2"></i>
    <p class="m-0">Aucune ligne selectionnée</p>
  </div>

</ng-template>

<!--  MODAL pour l'insertion de document -->
<ng-template #ModalInsertDoc let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title q-c-main">Ajouter un document au stage</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <q-insertdoc class="h-100 w-100" [item]="insertDocModel" [registerMode]="'UPLOADDOCWOLINK'" (success)="modal.dismiss();refreshGrid()" [effectifs]="effectifs"></q-insertdoc>
    </div>
  </div>
</ng-template>

<!--  MODAL de validation de la suppression des documents -->
<ng-template #ModalDeleteValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer définitivement ces documents ?</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="deleteSelection();modal.dismiss()"
              title="Supprimer les documents" [disabled]="!selectedNodes?.length">
        Supprimer
      </button>
    </div>
  </div>
</ng-template>
